module.exports = __webpack_public_path__ + "static/media/instagramIcon.21eab404.svg";